import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { UserProductGroup, UserProductGroupErrorResponse } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashErrorMessage } from '~/FlashMessage';
import { redirectFromDeletedGroup, selectUpdate, updateGroup } from '~/ProductGroup';
import CreateModal from '~/ProductGroup/CreateModal/CreateModal';
import { ApplicationState, ThunkDispatch } from '~/Store';

function mapStateToProps(
	state: ApplicationState,
	props: {
		group: UserProductGroup;
	}
) {
	const { accessToken } = state.accessToken;
	const systemModules = accessToken?.subscription?.systemModules || null;

	return {
		title: (props.group.isGroup() ? 'Rename folder: ' : 'Rename list: ') + props.group.name,
		namePlaceholder: props.group.isGroup() ? 'Folder name' : 'List name',
		initialInputValue: props.group.name,
		isFetching: selectUpdate(state.productGroup, props.group.id) !== null,
		isCzReimbursmentPrefillAllowed: Boolean(systemModules?.has('cz-reimbursement-prefill-assistant')),
	};
}

function mapDispatchToProps(
	dispatch: ThunkDispatch<AnyAction>,
	props: {
		group: UserProductGroup;
		onClose: () => void;
		onSave: (productGroup: UserProductGroup) => Promise<{ moduleError: string | null }>;
	}
) {
	return {
		onSave: (name: string) => {
			const result = { moduleError: null };

			return dispatch(updateGroup(props.group.id, name))
				.then((response) => {
					props.onSave(response.productGroup);
					return result;
				})
				.catch((response) => {
					if (!(response instanceof UserProductGroupErrorResponse)) {
						dispatch(handleError(response));
						return result;
					}
					if (response.handleProductGroupNotFound()) {
						props.onClose();
						dispatch(redirectFromDeletedGroup(props.group));
						dispatch(flashErrorMessage('Product list was removed, while you were renaming it'));
					}
					if (response.handleProductGroupLocked()) {
						dispatch(flashErrorMessage('Product list cannot be renamed now, please try it again'));
					}
					dispatch(handleError(response));
					return result;
				});
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateModal);
